import React, { useEffect, useState } from "react";

import Dashboard from "../PureComponents/Dashboard";
import ImageLoader from "Hooks/ImageLoader";
import { getGeneralInfo } from "Config/API/get";
import { renderGeneralInfo } from "Redux/action/render.action";
import { useDispatch } from "react-redux";

const RenderDashboard = () => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [imageLoader, setImageLoader] = useState(true);

  useEffect(() => {
    // general info rendering
    getGeneralInfo(token)
      .then((res) => {
        if (res?.status) {
          dispatch(renderGeneralInfo(res?.org_info));
          setImageLoader(false);
        }
      })
      .catch(() => {
        setImageLoader(false);
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return imageLoader ? <ImageLoader /> : <Dashboard />;
};

export default RenderDashboard;
